module.exports = __webpack_public_path__ + "static/media/logo-regione-emilia-romagna.c5d23deb.png";